import {Box} from '@mui/material';
import {MainFooter, PageWrapperLayout} from 'presentation/components';
import {PlanTypeEnum} from 'presentation/constants/bookingTypesEnum';
import {GuideStep} from 'presentation/modules/guide/shared/constants/constants';
import {EarlyAccessModal} from 'presentation/modules/guide/shared/ui/components';
import {Location} from 'presentation/modules/guide/shared/ui/components/Location';
import {SearchDetails} from 'presentation/modules/guide/shared/ui/components/SearchDetails';
import React from 'react';
import {useHealthGuide} from './hooks/useHealthGuide';

import {HealthGuideHeader} from './components/HealthGuideHeader';

import {HealthProvidersResultsV1} from './components/HealthProvidersResults/components/HealthProvidersResultsV1';
import {HealthProvidersResultsV3} from './components/HealthProvidersResults/components/HealthProvidersResultsV3';

export const HealthGuide = () => {
	const {
		shouldRenderEmptyState,
		isFetching,
		networkList,
		refetchProvidersQuery,
		isMobile,
		currentStepState,
		allProviders,
		providersError,
		onSearchResults,
		isEarlyAccessModalOpen,
		setIsEarlyAccessModalOpen,
		beneficiary,
		getNetworkInfo,
		showProvidersV3Component,
	} = useHealthGuide();

	const networkTitle = getNetworkInfo().title;

	return (
		<PageWrapperLayout title={networkTitle}>
			<HealthGuideHeader allProviders={allProviders} />

			{!currentStepState || currentStepState === GuideStep.LOCATION ? (
				<Location flowType={PlanTypeEnum.HEALTH} />
			) : null}

			{currentStepState === GuideStep.DETAILS ? (
				<SearchDetails type={PlanTypeEnum.HEALTH} onSearchResults={onSearchResults} />
			) : null}

			{currentStepState === GuideStep.RESULTS && !showProvidersV3Component ? (
				<HealthProvidersResultsV1
					isFetching={isFetching}
					shouldRenderEmptyState={shouldRenderEmptyState}
					networkList={networkList}
					refetchProvidersQuery={refetchProvidersQuery}
					providersError={providersError}
				/>
			) : null}

			{currentStepState === GuideStep.RESULTS && showProvidersV3Component ? (
				<HealthProvidersResultsV3 />
			) : null}

			<EarlyAccessModal
				open={isEarlyAccessModalOpen}
				onClose={() => setIsEarlyAccessModalOpen(false)}
				dtAdesao={beneficiary.dtAdesaoC}
			/>

			<Box
				mt="auto"
				mb={isMobile && currentStepState === GuideStep.DETAILS ? '65px' : undefined}>
				<MainFooter />
			</Box>
		</PageWrapperLayout>
	);
};
